// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { DATASTORE_ACTIONS } from '../../commons/DatastoreConstants';

export const dispatchSetLoading = (loading) => ({ type: DATASTORE_ACTIONS.SET_LOADING, loading });

export const dispatchResetValidationState = () => ({ type: DATASTORE_ACTIONS.RESET_VALIDATION_STATE });
export const dispatchSetValidationState = (validationState) => ({
  type: DATASTORE_ACTIONS.SET_VALIDATION_STATE,
  validationState,
});
export const dispatchUpdateValidationState = (validationStatePatch) => ({
  type: DATASTORE_ACTIONS.UPDATE_VALIDATION_STATE,
  validationStatePatch,
});

export const dispatchDeleteRunner = (runnerId) => ({ type: DATASTORE_ACTIONS.DELETE_RUNNER, runnerId });
export const dispatchSelectDatastore = (datasetId) => ({ type: DATASTORE_ACTIONS.SELECT_DATASTORE, datasetId });
export const dispatchSelectDefaultDatastore = (selectableDatasets) => ({
  type: DATASTORE_ACTIONS.SELECT_DEFAULT_DATASTORE,
  selectableDatasets,
});

export const dispatchStartDatastoreRunner = (runnerId, runnerType) => ({
  type: DATASTORE_ACTIONS.TRIGGER_SAGA_START_DATASTORE_RUNNER,
  runnerId,
  runnerType,
});

export const dispatchAddWorkspaceFilePath = (path) => ({ type: DATASTORE_ACTIONS.ADD_WORKSPACE_FILE_PATH, path });
export const dispatchAddWorkspaceFilePaths = (paths) => ({ type: DATASTORE_ACTIONS.ADD_WORKSPACE_FILE_PATHS, paths });
export const dispatchFetchAllWorkspaceFiles = () => ({
  type: DATASTORE_ACTIONS.TRIGGER_SAGA_FETCH_ALL_WORKSPACE_FILES,
});
export const dispatchUploadDatastoreFiles = (files) => ({
  type: DATASTORE_ACTIONS.TRIGGER_SAGA_UPLOAD_DATASTORE_FILES,
  files,
});
export const dispatchDeleteDatastoreFiles = (filePaths) => ({
  type: DATASTORE_ACTIONS.TRIGGER_SAGA_DELETE_DATASTORE_FILES,
  filePaths,
});
export const dispatchRemoveWorkspaceFilePath = (path) => ({ type: DATASTORE_ACTIONS.REMOVE_WORKSPACE_FILE_PATH, path });
export const dispatchRemoveWorkspaceFilePaths = (paths) => ({
  type: DATASTORE_ACTIONS.REMOVE_WORKSPACE_FILE_PATHS,
  paths,
});

export const dispatchStopAllRunnerStatusPollings = () => ({ type: DATASTORE_ACTIONS.STOP_ALL_RUNNER_STATUS_POLLINGS });
